import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const contactDetails = [{
  id: "address",
  icon: MapPin,
  title: "Helyszín",
  content: "Budapest Airport",
  highlight: "Terminál 2A & 2B",
  href: "/ContactPage"
}, {
  id: "phone",
  icon: Phone,
  title: "Foglalás",
  content: "+36 1 234 5678",
  highlight: "Azonnali visszaigazolás",
  href: "tel:+3612345678"
}, {
  id: "email",
  icon: Mail,
  title: "Ügyfélszolgálat",
  content: "taxi@travel.hu",
  highlight: "24 órás válaszidő",
  href: "mailto:taxi@travel.hu"
}, {
  id: "hours",
  icon: Clock,
  title: "Elérhetőség",
  content: "Hétfő - Vasárnap",
  highlight: "0-24 Non-stop",
  href: "/TaxiBookingPage"
}];
export default function ContactInfo() {
  return <section data-section-id="245249" id="taxibookingform" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold text-secondary mb-4 tracking-tight">
            Taxi és Transzfer Információk
          </h2>
          <p className="text-muted-foreground font-sans max-w-2xl mx-auto text-lg leading-relaxed">
            Megbízható reptéri transzfer és városi taxi szolgáltatás. Foglaljon előre fix áron, rejtett költségek nélkül a TRAVEL keresőmotorjával.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {contactDetails.map((item, i) => {
          const Icon = item.icon;
          return <Card key={item.id} data-index={i} className="border-border shadow-lg hover:shadow-xl transition-all duration-300 bg-card rounded-2xl h-full flex flex-col">
                <CardHeader className="flex flex-col items-center pb-4 pt-8">
                  <div className="p-4 bg-primary/10 rounded-full mb-4 group-hover:bg-primary/20 transition-colors">
                    <Icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-secondary text-center font-default text-xl font-bold">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center pb-8 flex-grow flex flex-col justify-between">
                  <div className="mb-4">
                    <Link to={item.href} className="inline-block hover:text-primary transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md">
                      <span className="text-foreground font-sans font-semibold text-lg">
                        {item.content}
                      </span>
                    </Link>
                  </div>
                  <span className="text-primary font-sans font-bold text-xs uppercase tracking-widest block mt-auto bg-primary/5 py-1 px-3 rounded-full">
                    {item.highlight}
                  </span>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}